import * as contentImages from './contentImages.js'

function getItineraryImage (content) {
  const images = content.images
  const photo = contentImages.largestImage(contentImages.imagesSmallerThan(contentImages.imagesWithName(images, 'primary_image'),1500)) ||
  contentImages.smallestImage(contentImages.imagesOfType(images, 'banner')) ||
  contentImages.largestImage(contentImages.imagesSmallerThan(contentImages.imagesOfType(images, 'photo'),1500))
  return photo && photo.url && photo.url.replace('contentuat','content').replace('overlay=1','')
}

function getMapImage (content) {
  const mapImage = contentImages.largestImage(contentImages.imagesOfType(content.images, 'map'))
  return mapImage && mapImage.url.replace('contentuat','content')
}

function getTourHeaderDetails (content, departure, numberOfPassengers) {
  const imageUrl = getItineraryImage(content)
  return {
    imageUrl,
    mapUrl: getMapImage(content),
    photoInlineStyles: imageUrl ? {backgroundImage: `url('${imageUrl}')`} : undefined,
    tourName: departure.name,
    tourBrochureName: departure.brochureName,
    startDate: departure.originDepartureDate || departure.startDate,
    endDate: departure.endDate,
    itinerary: content.itinerary,
    countries: content.countriesVisited ? content.countriesVisited.length : 1,
    days: (departure.originDepartureDate || departure.startDate).differenceInDays(departure.endDate) + 1,
    passengers: numberOfPassengers,
  }
}

export {
  getItineraryImage,
  getMapImage,
  getTourHeaderDetails,
}